module.exports = __webpack_public_path__ + "static/media/background.81b86b35.jpg";